import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FeatureSelectionOptionsContext } from "./FeatureSelectionOptionsContext";
import FeatureManagementSettings from "../pages/FeatureManagementSettings";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { fetchAndSetUiConfigOptions, getMetaDataConfig, setAppAndRoleOptions } from "../../../services/uiConfigService";
import { AppOptionType, OptionType } from "../../manageHomepage/ManageHomePageTypes";
interface Props {
  children?: React.ReactNode; 
}

const FeatureSelectionProviderWrapper = ({ children }: Props) => {
  const [uiConfigOptionsProp, setUiConfigOptionsProp] = useState<otherConfigOptionsAttributes[]>([]);
  const clientConfigRef = useRef<any>(null);
  const savedAppType = useSelector((state: any) => state.appTypeState.appType);
  const allConfigRef = useRef<otherConfigOptionsAttributes[]>([]);
  const savedRole = useSelector((state: any) => state.roleState.role) ?? savedAppType?.designations?.[0];
  const [appTypeOptions, setAppTypeOptions] = useState<AppOptionType[]>([]);
  const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
  const setUiConfigOptionsAccToAppType = async (savedAppType: AppOptionType) => {
    if (!savedAppType?.id) return;

    const allConfigs = allConfigRef.current ?? [];

    const filteredConfigs = allConfigs?.filter((option: any) => 
      !option.hasOwnProperty('supportedAppTypes') || option.supportedAppTypes?.length === 0 ||
      option.supportedAppTypes?.includes(savedAppType?.id?.toLowerCase())
    );

    setUiConfigOptionsProp(filteredConfigs);
  };
  const init = async () => {
    const clientConfig = await getMetaDataConfig("clientconfig");
    clientConfigRef.current = clientConfig;
     const resp = setAppAndRoleOptions({
        setAppTypeOptions: setAppTypeOptions,
        setRoleOptions: setRoleOptions,
        clientConfig: clientConfig,
        savedRole: savedRole
    });
    const allConfigs = await fetchAndSetUiConfigOptions();
    allConfigRef.current = allConfigs;
    setUiConfigOptionsAccToAppType(resp.appType ?? savedAppType);
  }
  useEffect(() => {
    setUiConfigOptionsAccToAppType(savedAppType);
  }, [savedAppType?.id]);
  useEffect(()=>{
    // debugger;
    init();
  },[])
  return (
    <FeatureSelectionOptionsContext.Provider
      value={{ uiConfigOptionsProp, setUiConfigOptionsProp }}
    >
      {children ? (
        children
      ) : (
        <FeatureManagementSettings
          uiConfigOptionsProp={uiConfigOptionsProp}
          setUiConfigOptionsProp={setUiConfigOptionsProp}
        />
      )}
    </FeatureSelectionOptionsContext.Provider>
  );
};

export default FeatureSelectionProviderWrapper;
